import { render } from "./New_WarehouseManagementTab.vue?vue&type=template&id=626e3870"
import script from "./New_WarehouseManagementTab.vue?vue&type=script&lang=js"
export * from "./New_WarehouseManagementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__